
import { Component, Prop, Vue } from "vue-property-decorator";
import settings from "@/settings";
import { UserModule } from "@/store/modules/user";

@Component({
    name: "SidebarLogo",
})
export default class extends Vue {
    @Prop({ required: true }) private collapse!: boolean;

    private title = settings.title;

    get brandName() {
        return (this.info.admin_name || '神阁电竞').replace(/\s*[-－—]\s*后台管理平台.*$/, '');
    }

    get info() {
        return UserModule.mainInfo as typeof UserModule.mainInfo & {admin_name?: string; admin_logo?: string};
    }
}
